import PermissionDenied from '@/views/PermissionDenied/index.vue';

export const commonRoutes = {
  path: 'permission-denied',
  name: 'permissionDenied',
  component: PermissionDenied,
};
